import Link from "next/link";
import { downloadLink } from "@/lib/utils.js";
import ResourcesModal from "@/components/resources_modal";
import { useState } from "react";
import ShareSvg from "@/components/svgs/share_svg.js";
import DownloadSvg from "@/components/svgs/download_svg.js";
import ResourceList from "@/components/resource_list";
import BulkAssetLinks from '@/components/bulk_asset_links.js'

export default function ResourceSection ({downloads, product, config, resource_display, _classes }) {
 
 const [show, setShow] = useState(false);

  const downloadContainerId = (category) => {
    let categoryId = category
      .toLowerCase()
      .replace("&", "and")
      .trim()
      .replace(/\s/g, "-");
    return `download-cateogry-${categoryId}`;
  };

  return  (
    <div  className={_classes ? _classes : "lexcms-product-downloads-section" }>
      {Object.keys(downloads || {}).map((resourceCategory, i) => {
        const slicedDownloads =
          resource_display === "modal"
            ? downloads[resourceCategory]?.slice(0, 3)
            : downloads[resourceCategory];
        return (
          <div key={i} className='lexcms-product-download-container'
            id={`${downloadContainerId(resourceCategory)}`}
          >
              
            <div
              className="lexcms-product-download-container-inner"
            >
              <span>
                <h4 className="lexcms-product-download-heading">
                  {resourceCategory}
                </h4>
                {resource_display === "modal" && (
                  <div>
                    {downloads[resourceCategory]?.length > 3 && (
                      <div
                        className="lexcms-product-download-view-all-section"
                        onClick={() => setShow(resourceCategory)}
                      >
                        <div className="lexcms-product-download-view-all">
                          View All
                        </div>
                        <div className="lexcms-product-download-view-all-count">
                          ({downloads[resourceCategory]?.length})
                        </div>
                        <div className="lexcms-product-download-view-all-icon"></div>
                      </div>
                    )}
                  </div>
                )}
              </span>

              <hr className="lexcms-section-divider"></hr>

              <ul className="lexcms-product-download-list">
                {slicedDownloads?.map((d, i) => {
                  return (
                    <li
                      key={i}
                      className="lexcms-product-download-filename"
                    >
                      <Link href={downloadLink(d)}>
                        <a target="_blank">{d.name}</a>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            {resource_display === "modal"   && (
              <ResourcesModal
                show={show === resourceCategory}
                no_close_on_outside_click={true}
                setShow={setShow}> <h3>
                  <strong>{product.name}</strong>: {resourceCategory}{" "}
                </h3>
                <hr className="lexcms-section-divider"></hr>
                <ul className="lexcms-product-download-list">
                  {downloads[resourceCategory]?.map((d, i) => {
                    return (
                      <li
                        key={i}
                        className="lexcms-product-download-filename"
                      >
                        <Link href={downloadLink(d)}>
                          <a target="_blank">{d.name}</a>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </ResourcesModal>
            )}

          </div>
        );
      })}
      <BulkAssetLinks product={product} config={config} />
    </div>

  )
}

 

